export enum BookedVisitDateRangeCriteriaType {
  ONLY_UPCOMING = 'ONLY_UPCOMING',
  START_DATE = 'START_DATE',
  ALL_TIME = 'ALL_TIME',
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  SEVEN_DAYS = 'SEVEN_DAYS',
  THIRTY_DAYS = 'THIRTY_DAYS',
}
